import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  padding: 1rem 1rem 0.5rem;
  gap: 1rem;
`;

export const Title = styled.h6`
  font-weight: bold;
  color: #000;
`;

export const FooterButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 1rem;
  margin-bottom: 1rem;

  > button {
    max-width: 200px;
  }
`;
export const BoxModal = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
`;

export const TitleModal = styled.h6`
  font-weight: bold;
  color: #000;
  text-align: center;
`;

export const ButtonImages = styled.div`
  @media (max-width: 768px) {
    width: 100%;
    button {
      padding: 5px;
      max-width: unset;
      min-width: 77px;
    }
  }
`;

export const ColumnLabelButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 768px) {
    gap: 15px;
    flex-direction: column;
  }
`;

